import React, { useEffect } from 'react'
import { Portada } from '../components/Home/Portada'
// import { FollowOrder } from '../components/Home/FollowOrder'
import { WhyUs } from '../components/Home/WhyUs'
import { OurPartners } from '../components/Home/OurPartners'
import { Integrations } from '../components/Home/Integrations'
import { Map } from '../components/Home/Map'
import { Testimonials } from '../components/Home/Testimonials'
import { Digits } from '../components/Home/Digits'
import Layout from './../components/layout';
import { GTMDataLayerPusher } from '../components/Analytics/TagManager'

function Home() {

  useEffect(() => {
    const gtmData = {
      event: "see_home",
      pagePath: "index",
      pageTitle: "HomePage",
    };

    GTMDataLayerPusher(gtmData);

  }, []);

  

  return (
    <Layout>
        <Portada />
        {/* <FollowOrder /> */}
        <WhyUs />
        <OurPartners />
        <Integrations />
        <Map />
        <Digits />
        <Testimonials />
    </Layout>
  )
}

export default Home;